// Зеркало реестра роутов бэкенда `Contracts.Api.ApiRoutes` (backend/src/Contracts/Api/ApiRoutes.cs).
// Правило версионирования: вся клиентская поверхность — под /api/v1; ломающее изменение
// схемы = параллельные V2-эндпоинты (не миграторы клиента). Менять СИНХРОННО с бэкендом.
export const API_V1 = '/api/v1';
// дев-роуты (вне версионирования v1) — зеркало Contracts.Api.ApiRoutes.Dev.
// Маппятся ТОЛЬКО на деве (Program.cs: не-Production И Dev:CheatsEnabled).
export const API_DEV = '/api/dev';

export const routes = {
  // инфра-смоук
  ping: `${API_V1}/ping`,

  // auth (M1, §2)
  authStart: (provider: string) => `${API_V1}/auth/${provider}/start`,
  authCallback: (provider: string) => `${API_V1}/auth/${provider}/callback`,
  authRefresh: `${API_V1}/auth/refresh`,
  authLogout: `${API_V1}/auth/logout`,

  // профиль/связки/право (M1/M6)
  me: `${API_V1}/me`,
  meExport: `${API_V1}/me/export`,
  meIdentity: (provider: string) => `${API_V1}/me/identities/${provider}`,
  meIdentityLinkConfirm: `${API_V1}/me/identities/link/confirm`,

  // прогресс (M2, §5)
  meProgress: `${API_V1}/me/progress`,
  meProgressClaim: `${API_V1}/me/progress/claim`,
  meCollection: `${API_V1}/me/collection`,
  meAchievements: `${API_V1}/me/achievements`,

  // контент (M2, §4)
  manifest: `${API_V1}/manifest`,
  // сервис ассетов: каталог медиа плееров на S3/CDN (публичный, без Bearer)
  assets: `${API_V1}/assets`,
  levelConfig: (levelId: string) => `${API_V1}/levels/${levelId}/config`,
  levelResult: (levelId: string) => `${API_V1}/levels/${levelId}/result`,

  // платежи (M3, §3)
  paymentsCheckout: `${API_V1}/payments/checkout`,
  paymentOrder: (orderId: string) => `${API_V1}/payments/${orderId}`,

  // UGC (M4, §6)
  ugcLevels: `${API_V1}/ugc/levels`,
  ugcCatalog: `${API_V1}/ugc/catalog`,
  ugcLevel: (id: string) => `${API_V1}/ugc/levels/${id}`,
  ugcLevelShare: (id: string) => `${API_V1}/ugc/levels/${id}/share`,
  ugcLevelPlay: (id: string) => `${API_V1}/ugc/levels/${id}/play`,
  ugcLevelPublish: (id: string) => `${API_V1}/ugc/levels/${id}/publish`,
  ugcLevelLike: (id: string) => `${API_V1}/ugc/levels/${id}/like`,
  ugcLevelReport: (id: string) => `${API_V1}/ugc/levels/${id}/report`,
  ugcLevelBySlug: (slug: string) => `${API_V1}/ugc/levels/by-slug/${slug}`,

  // аналитика (M5, §7)
  analyticsEvents: `${API_V1}/analytics/events`,
} as const;

// Дев-роуты (вне версионирования v1, зеркало Contracts.Api.ApiRoutes.Dev).
// Отдельно от `routes`, т.к. это НЕ клиентская v1-поверхность — маппятся только
// на деве (Program.cs: не-Production И Dev:CheatsEnabled).
export const devRoutes = {
  // wildcard-уровень по slug без гейтинга/auth (дизайн 2026-07-08)
  wildcard: (slug: string) => `${API_DEV}/wildcard/${slug}/config`,
  // снимок уровня из конструктора «Поделиться»: POST — положить, {id}/config — сыграть/открыть
  sharedLevels: `${API_DEV}/shared-levels`,
  sharedLevel: (id: string) => `${API_DEV}/shared-levels/${id}/config`,
} as const;
